/**
 * Service helpers do Revisor de Lista de Ferragens.
 * Todas as chamadas passam pelo `request` do AuthContext (proxy do backend).
 */

export function listarProjetos(request, { p = 1, q = 20, s = "", status = "" } = {}) {
  const params = new URLSearchParams();
  params.set("p", String(p));
  params.set("q", String(q));
  if (s) params.set("s", s);
  if (status) params.set("status", status);
  return request(`/api/revisor-ferragens/projetos?${params.toString()}`, {
    silentError: true,
  });
}

export function obterProjeto(request, projectId) {
  return request(
    `/api/revisor-ferragens/projetos/${encodeURIComponent(projectId)}`,
    { silentError: true },
  );
}

export function criarLista(request, payload) {
  return request("/api/revisor-ferragens/listas", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function listarListas(request) {
  return request("/api/revisor-ferragens/listas");
}

export function obterLista(request, id) {
  return request(`/api/revisor-ferragens/listas/${id}`);
}

export function excluirLista(request, id) {
  return request(`/api/revisor-ferragens/listas/${id}`, {
    method: "DELETE",
    silentError: true,
  });
}

export function conferirItem(request, listaId, itemId, conferido) {
  return request(
    `/api/revisor-ferragens/listas/${listaId}/itens/${itemId}`,
    { method: "PATCH", body: JSON.stringify({ conferido }), silentError: true },
  );
}

/**
 * Edita um item da lista salva (PATCH parcial): `nome`, `quantidade`,
 * `dimensoes` e/ou `oculto`. Ocultar tira o item da impressão E da requisição
 * de separação (o checklist do almoxarife conta só os não-ocultos).
 */
export function atualizarItemLista(request, listaId, itemId, patch) {
  return request(
    `/api/revisor-ferragens/listas/${listaId}/itens/${itemId}`,
    { method: "PATCH", body: JSON.stringify(patch), silentError: true },
  );
}

export function adicionarItemLista(request, listaId, payload) {
  return request(`/api/revisor-ferragens/listas/${listaId}/itens`, {
    method: "POST",
    body: JSON.stringify(payload),
    silentError: true,
  });
}

export function removerItemLista(request, listaId, itemId) {
  return request(`/api/revisor-ferragens/listas/${listaId}/itens/${itemId}`, {
    method: "DELETE",
    silentError: true,
  });
}
